var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovalCroppedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 104,
    viewBox: "0 0 247 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6699_40692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.62 23.803L101.776 7.63685L64.7759 -1.25514L6.78027 32.2875L87.0553 133.36L165.515 87.8625L149.855 68.1519",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1521 19.5177L60.8857 0.955653L64.7636 -1.27969L81.1521 19.5177Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1521 19.5177L60.8857 0.955653L64.7636 -1.27969L81.1521 19.5177Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.708 71.6224C107.137 66.1143 101.554 56.7777 101.666 48.0956C94.8855 46.5766 87.7842 47.5893 81.6833 50.9485C69.3086 58.1115 67.2338 73.9689 77.0644 86.3189C86.895 98.6936 104.889 102.893 117.264 95.7048C124.439 91.6911 128.638 83.8859 128.033 75.6855C124.044 75.0433 120.203 73.6725 116.708 71.6347V71.6224Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.708 71.6224C107.137 66.1143 101.554 56.7777 101.666 48.0956C94.8855 46.5766 87.7842 47.5893 81.6833 50.9485C69.3086 58.1115 67.2338 73.9689 77.0644 86.3189C86.895 98.6936 104.889 102.893 117.264 95.7048C124.439 91.6911 128.638 83.8859 128.033 75.6855C124.044 75.0433 120.203 73.6725 116.708 71.6347V71.6224Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74 7.58761L81.1521 19.5177L64.7637 -1.27969",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1592 40.1299L65.6404 20.1722",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.916 53.7149L95.5521 22.667",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9717 82.0705L106.853 85.5038L106.013 64.9286",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.372 30.0646L104.073 39.1666C98.0466 49.5776 103.703 64.1136 116.695 71.61C128.341 78.3531 143.865 77.9332 151.176 66.2378L156.376 57.2099",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.387 21.6049C113.99 23.4944 110.508 27.0512 108.717 31.4849C104.246 42.464 111.397 55.2957 122.463 61.6806C132.318 67.374 145.174 67.9174 153.177 60.8902C154.4 59.8158 155.474 58.5931 156.388 57.247",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.004 -14.7783L183.212 -4.7871C181.063 -1.0574 176.518 0.906249 171.43 0.906249C156.536 0.906249 144.347 -14.4324 149.892 -24.0284L155.659 -34.0195C153.041 -29.4624 154.56 -23.8678 157.462 -19.6441C165.885 -7.34355 183.83 -5.86155 189.017 -14.7906L189.004 -14.7783Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.777 24.6306C202.565 39.537 188.325 56.4565 176.753 65.719C172.69 65.1015 168.726 63.9777 164.946 62.3598C157.611 58.6795 151.053 53.616 145.643 47.441L153.955 33.1521C152.621 30.7191 151.398 28.2368 150.312 25.6803C149.188 26.2361 147.916 26.4213 146.668 26.2114C148.583 32.4234 145.903 35.0293 141.741 34.4982C143.544 40.2657 139.431 42.6492 133.8 40.5003C134.59 45.0451 128.069 45.7367 122.833 41.3401C118.671 37.8451 112.039 27.9774 116.534 23.5561C117.103 23.0127 117.831 22.6546 118.609 22.5558C117.769 19.3571 117.992 16.1214 121.104 14.2442C121.61 13.9231 122.191 13.7255 122.784 13.6391C121.894 8.63734 124.525 5.17935 128.39 4.04315C128.465 1.462 129.897 -0.884506 132.145 -2.14421C130.181 -5.16996 128.65 -8.4674 127.588 -11.9254C126.39 -16.8531 130.181 -19.78 135.22 -15.8898C136.875 -14.6054 139.073 -12.7652 141.691 -10.641C142.42 -11.0609 149.25 -14.4201 149.25 -14.4201C149.521 -13.5803 149.855 -12.7776 150.25 -11.9872C150.25 -11.9872 149.015 -9.83825 147.027 -6.45435C153.399 -1.68725 161.266 3.40095 169.652 6.155L172.665 0.967999C176.21 0.881549 179.581 -0.588107 182.076 -3.11986C189.93 3.75909 186.139 0.0911492 209.777 24.6429V24.6306Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.959 62.3475C163.28 66.5712 162.996 69.634 164.428 70.8196C166.343 72.4128 170.961 70.3009 176.778 65.7067C172.74 65.0028 168.776 63.8666 164.959 62.3475Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.959 62.3475C163.28 66.5712 162.996 69.634 164.428 70.8196C166.343 72.4128 170.961 70.3009 176.778 65.7067C172.74 65.0028 168.776 63.8666 164.959 62.3475Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.194 16.739L209.777 24.6306C214.94 13.3551 211.16 10.7122 202.194 16.739Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.194 16.739L209.777 24.6306C214.94 13.3551 211.16 10.7122 202.194 16.739Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.363 57.2222C155.869 57.9879 155.313 58.7166 154.708 59.3958L145.631 47.441C148.83 51.0966 152.436 54.3694 156.363 57.2222Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.363 57.2222C155.869 57.9879 155.313 58.7166 154.708 59.3958L145.631 47.441C148.83 51.0966 152.436 54.3694 156.363 57.2222Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.252 40.4757C226.289 42.2047 224.918 43.6373 223.189 43.662C221.46 43.6867 220.028 42.3282 220.003 40.5992C220.003 40.5621 220.003 40.5127 220.003 40.4757C220.04 38.7467 221.473 37.3758 223.189 37.4129C224.869 37.4499 226.227 38.7961 226.252 40.4757Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.252 40.4757C226.289 42.2047 224.918 43.6373 223.189 43.662C221.46 43.6867 220.028 42.3282 220.003 40.5992C220.003 40.5621 220.003 40.5127 220.003 40.4757C220.04 38.7467 221.473 37.3758 223.189 37.4129C224.869 37.4499 226.227 38.7961 226.252 40.4757Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.678 0.893899C163.353 1.17795 154.671 -3.83615 150.262 -12.0612C150.262 -12.0612 149.027 -9.91235 147.039 -6.52845C153.412 -1.7737 161.279 3.32685 169.664 6.0809L172.678 0.893899Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.678 0.893899C163.353 1.17795 154.671 -3.83615 150.262 -12.0612C150.262 -12.0612 149.027 -9.91235 147.039 -6.52845C153.412 -1.7737 161.279 3.32685 169.664 6.0809L172.678 0.893899Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.918 33.1521C152.584 30.7192 151.362 28.2368 150.275 25.6804C149.151 26.2361 147.879 26.4214 146.632 26.2114C148.546 32.4235 145.866 35.0293 141.704 34.4983C143.507 40.2657 139.395 42.6493 133.763 40.5004C134.553 45.0452 128.033 45.7368 122.796 41.3402C122.549 41.1302 122.265 40.8462 121.932 40.5498C123.29 44.3165 125.995 47.4534 129.515 49.343C134.183 52.0229 142.062 53.3073 144.594 49.0836L153.906 33.1398L153.918 33.1521Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.918 33.1521C152.584 30.7192 151.362 28.2368 150.275 25.6804C149.151 26.2361 147.879 26.4214 146.632 26.2114C148.546 32.4235 145.866 35.0293 141.704 34.4983C143.507 40.2657 139.395 42.6493 133.763 40.5004C134.553 45.0452 128.033 45.7368 122.796 41.3402C122.549 41.1302 122.265 40.8462 121.932 40.5498C123.29 44.3165 125.995 47.4534 129.515 49.343C134.183 52.0229 142.062 53.3073 144.594 49.0836L153.906 33.1398L153.918 33.1521Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.918 33.1521C156.783 38.2897 160.525 43.2544 164.823 45.0822",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.051 -6.52845C141.555 -10.641 138.962 -13.0863 135.244 -15.9391C130.218 -19.7923 126.427 -16.9024 127.612 -11.9748C129.638 -3.5768 142.247 12.5646 147.78 19.0731C147.78 19.0731 148.669 21.8765 150.299 25.6803",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.754 8.00751C175.654 7.72346 172.604 7.06891 169.652 6.06856",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.734 13.2439C123.735 20.0117 130.577 27.5823 132.516 29.4471C134.998 32.0406 138.221 33.7943 141.741 34.4859",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.287 25.6804C147.607 27.0512 143.074 26.2114 137.863 21.4073C135.454 19.1843 128.156 10.6628 128.39 3.99376",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.622 22.5311C119.956 27.5205 124.031 32.8804 125.699 34.6712C127.934 37.2029 130.7 39.1913 133.8 40.5127",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.197 14.0837L240.207 39.1295",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.44 70.8443L191.734 94.7045",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6699_40692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 247,
    fill: "white",
    transform: "translate(0 -84)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalCroppedImg);
export default __webpack_public_path__ + "static/media/approval-cropped-img.d0dd06c384972d53b178ead809f03c0a.svg";
export { ForwardRef as ReactComponent };